<template>
    <el-dropdown trigger="click" @command="onCommand" class="notif-bell-dropdown">
        <span class="el-dropdown-link">
            <i class="fas fa-bell" :class="{ 'has-naolidas': total > 0 }"></i>
            <span v-if="total > 0" class="notif-badge">{{ total > 99 ? '99+' : total }}</span>
        </span>
        <el-dropdown-menu slot="dropdown" class="notif-menu">
            <div class="notif-header">
                <strong>Notificações</strong>
                <el-button v-if="total > 0" type="text" size="mini" @click="marcarTodas">Marcar todas como lidas</el-button>
            </div>
            <el-dropdown-item v-if="!total" disabled>
                <span class="u-text-muted">Você não tem notificações novas.</span>
            </el-dropdown-item>
            <el-dropdown-item v-for="n in itens" :key="n.id" :command="n">
                <div class="notif-item">
                    <strong>{{ n.titulo }}</strong>
                    <p>{{ n.mensagem }}</p>
                    <small class="u-text-muted">{{ formatData(n.created_at) }}</small>
                </div>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
const POLLING_MS = 5 * 60 * 1000;

export default {
    name: 'notification-bell',
    data: () => ({
        itens: [],
        total: 0,
        timer: null
    }),
    mounted(){
        this.carregar();
        this.timer = setInterval(() => this.carregar(), POLLING_MS);
    },
    beforeDestroy(){
        if(this.timer){ clearInterval(this.timer); }
    },
    methods: {
        carregar(){
            if(!this.$store.state.token){ return; }
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/notificacao/getNaoLidas`,
                this.$store.getters.getHeaderAuth
            ).then(response => {
                if(response.data && response.data.erro){ return; }
                this.itens = response.data.itens || [];
                this.total = response.data.total || 0;
            }).catch(() => { /* falha silenciosa — não atrapalha o app */ });
        },
        onCommand(notif){
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/notificacao/marcarLida/` + notif.id,
                {},
                this.$store.getters.getHeaderAuth
            ).then(() => {
                this.carregar();
                if(notif.link){ this.$router.push(notif.link).catch(() => {}); }
            }).catch(() => { /* silencioso */ });
        },
        marcarTodas(){
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/notificacao/marcarTodasLidas`,
                {},
                this.$store.getters.getHeaderAuth
            ).then(() => { this.carregar(); }).catch(() => {});
        },
        formatData(d){
            if(!d){ return ''; }
            return this.$moment(d).format('DD/MM/YYYY HH:mm');
        }
    }
}
</script>

<style scoped>
.notif-bell-dropdown{ position: relative; cursor: pointer; margin-right: 20px; }
.notif-bell-dropdown .fas.fa-bell{ font-size: 17px; color: #a9a9a9; }
.notif-bell-dropdown .fas.fa-bell.has-naolidas{ color: #F56C6C; }
.notif-badge{
    position: absolute;
    top: -8px;
    right: -10px;
    background: #F56C6C;
    color: #fff;
    border-radius: 10px;
    padding: 0 6px;
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    min-width: 16px;
    text-align: center;
}
.notif-menu{ width: 360px; max-height: 480px; overflow-y: auto; }
.notif-header{ display: flex; justify-content: space-between; align-items: center; padding: 8px 16px; border-bottom: 1px solid #eee; }
.notif-item{ white-space: normal; line-height: 1.4; padding: 4px 0; }
.notif-item p{ margin: 4px 0; font-size: 12px; color: #555; }
</style>
